import { render, staticRenderFns } from "./DashboardSpree.vue?vue&type=template&id=3763da8a&scoped=true&"
import script from "./DashboardSpree.vue?vue&type=script&lang=js&"
export * from "./DashboardSpree.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSpree.vue?vue&type=style&index=0&id=3763da8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763da8a",
  null
  
)

export default component.exports